import { createSaga } from './saga-helpers';

import * as Api from '../api/files-api';

const watchGetFiles = createSaga({
    type: 'FILES_FETCH',
    fn: Api.fetchFiles,
    args: action => [action.payload],
    successPayload: ({ files, hasMore } = {}, action) => ({
        files,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        ...action.payload
    })
});

const watchUploadFiles = createSaga({
    type: 'FILES_UPLOAD',
    fn: Api.uploadFiles,
    args: action => [action.payload.files, action.payload.fileProps],
    successPayload: files => ({ files }),
    progressPayload: (progress, action) => ({ files: action.payload.files ? action.payload.files.map(({ name }) => ({ name })) : [], progress }),
    progress: true
});

const watchGetFile = createSaga({
    type: 'FILE_FETCH',
    fn: Api.fetchFile,
    args: action => [action.payload.fileId],
    successPayload: file => ({ file })
});

const watchUpdateFile = createSaga({
    type: 'FILE_UPDATE',
    fn: Api.updateFile,
    args: action => [action.payload.fileId, action.payload.fileProps],
    successPayload: file => ({ file })
});

const watchAddFileLabels = createSaga({
    type: 'FILE_LABELS_ADD',
    fn: Api.addFileLabels,
    args: action => [action.payload.fileId, action.payload.labels]
});

const watchRemoveFileLabels = createSaga({
    type: 'FILE_LABELS_REMOVE',
    fn: Api.removeFileLabels,
    args: action => [action.payload.fileId, action.payload.labels]
});

const watchRemoveFile = createSaga({
    type: 'FILE_REMOVE',
    fn: Api.removeFile,
    args: action => [action.payload.fileId]
});

const watchCopyFile = createSaga({
    type: 'FILE_COPY',
    fn: Api.copyFile,
    args: action => [action.payload.fileId, action.payload.copyOptions]
});

const sagas = [watchGetFiles, watchUploadFiles, watchGetFile, watchUpdateFile, watchAddFileLabels, watchRemoveFileLabels, watchRemoveFile, watchCopyFile];

export default sagas;
